import Tool, { type ToolArgs } from '../../../tools/Tool';
import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import attachmentNoIconSvg from '../../../assets/icons/attachmentNoIcon.svg';
import attachmentIconLeftSvg from '../../../assets/icons/attachmentIconLeft.svg';
import attachmentIconTopSvg from '../../../assets/icons/attachmentIconTop.svg';
import { isAttachmentElement } from '../../../types/guards';

class ToolAttachmentDisplay extends Tool {
  static toolName = 'Display style';
  static attachmentDisplay: 'link' | 'icon-left' | 'icon-above';
  static iconSvg: any;

  static action({ editor, element }: ToolArgs): void {
    if (!element || !isAttachmentElement(element)) return;

    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(
      editor,
      { attachment_display: this.attachmentDisplay },
      {
        at: path,
      }
    );
  }

  static isActive({ editor, element }: ToolArgs): boolean {
    return Boolean(
      element &&
        isAttachmentElement(element) &&
        element.attachment_display === this.attachmentDisplay
    );
  }

  static renderToolbarButtonIcon({ editor }: ToolArgs): JSX.Element {
    return svgToIcon(this.iconSvg);
  }
}

class ToolAttachmentDisplayLink extends ToolAttachmentDisplay {
  static toolName = 'Link';
  static iconSvg = attachmentNoIconSvg;
  static attachmentDisplay = 'link' as 'link';
}

class ToolEmbedDisplayIconLeft extends ToolAttachmentDisplay {
  static toolName = 'Icon left';
  static iconSvg = attachmentIconLeftSvg;
  static attachmentDisplay = 'icon-left' as 'icon-left';
}

class ToolEmbedDisplayIconAbove extends ToolAttachmentDisplay {
  static toolName = 'Icon above';
  static iconSvg = attachmentIconTopSvg;
  static attachmentDisplay = 'icon-above' as 'icon-above';
}

export {
  ToolAttachmentDisplayLink,
  ToolEmbedDisplayIconLeft,
  ToolEmbedDisplayIconAbove,
};
